import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSearch,
  faChevronDown,
  faChevronUp,
  faMapMarkerAlt,
  faCircle,
  faExternalLinkAlt,
  faFileWord,
  faTrashAlt,
  faPlusSquare,
  faTimes,
  faPen,
  faCloudUploadAlt,
  faCheck,
  faUndo,
  faEye,
  faDownload,
  faBell,
  faUserCircle,
  faCog,
  faCar,
  faRetweet,
  faWrench,
  faFileAlt,
  faIdBadge,
  faBriefcase,
  faArrowsAltH,
  faUserLock,
  faFilePdf,
  faFile,
  faSortAmountDownAlt,
  faSortAmountUpAlt,
  faParking,
  faRoute,
  faClock,
  faTachometerAlt,
  faRoad,
  faFlag,
  faFlagCheckered,
  faClipboardList,
  faArrowLeft,
  faSearchLocation,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faTools,
  faSort,
  faSortUp,
  faSortDown,
  faGripLines
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserLock)
library.add(faArrowsAltH)
library.add(faBriefcase)
library.add(faFileWord)
library.add(faTrashAlt)
library.add(faSearch)
library.add(faChevronDown)
library.add(faChevronUp)
library.add(faMapMarkerAlt)
library.add(faCircle)
library.add(faExternalLinkAlt)
library.add(faPlusSquare)
library.add(faTimes)
library.add(faPen)
library.add(faCloudUploadAlt)
library.add(faCheck)
library.add(faUndo)
library.add(faEye)
library.add(faDownload)
library.add(faBell)
library.add(faUserCircle)
library.add(faCog)
library.add(faCar)
library.add(faRetweet)
library.add(faWrench)
library.add(faFileAlt)
library.add(faIdBadge)
library.add(faFilePdf)
library.add(faFile)
library.add(faSortAmountDownAlt)
library.add(faSortAmountUpAlt)
library.add(faParking)
library.add(faRoute)
library.add(faClock)
library.add(faTachometerAlt)
library.add(faRoad)
library.add(faFlag)
library.add(faFlagCheckered)
library.add(faClipboardList)
library.add(faArrowLeft)
library.add(faSearchLocation)
library.add(faAngleDoubleRight)
library.add(faAngleDoubleLeft)
library.add(faTools)
library.add(faSort)
library.add(faSortUp)
library.add(faSortDown)
library.add(faGripLines)
Vue.component('font-awesome-icon', FontAwesomeIcon)
